/* istanbul ignore file */
export const PREFIX = "pta";
export const DELIMITER = `${PREFIX}-del`;
